/**
 * Match status formatting and display utilities
 * Shared across PublicMatches, MatchesDetailModal, and related components
 */

/**
 * Formats a status string for display by replacing underscores with spaces
 * @param status - The raw status string (e.g., "OFFER_ACCEPTED")
 * @returns Formatted status string (e.g., "OFFER ACCEPTED")
 */
export const formatStatusLabel = (status: string): string => {
  return status.replace(/_/g, ' ');
};

/**
 * Formats a match status for display with proper title case (e.g. "Offer Accepted")
 * @param status - The raw status string (e.g., "OFFER_ACCEPTED")
 * @returns Formatted status string (e.g., "Offer Accepted")
 */
export const formatMatchStatusLabel = (status: string): string => {
  if (!status || status === 'UNKNOWN') return 'Unknown';
  return status
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * List of all possible match statuses for filter dropdowns
 */
export const MATCH_STATUSES = [
  'NEW',
  'ACCEPTED',
  'INTERVIEWING',
  'SHORTLISTED',
  'OFFER_EXTENDED',
  'OFFER_ACCEPTED',
  'PLACED',
  'REJECTED',
  'AGENCY_REJECTED',
  'WITHDRAWN',
] as const;

export type MatchStatus = typeof MATCH_STATUSES[number];
